<svg class="circular-chart"  viewBox="0 0 36 36" >
    <path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
    <path class="circle" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" [attr.stroke-dasharray]="progress*100 + ',100'" stroke-dasharray="0,100"></path>
</svg>